import { useEffect } from 'react'
import useAppDispatch from '../../../../hooks/useAppDispatch'
import {
	fetchDeemedVat,
	fetchLastUploadedTansation,
	fetchNews,
	fetchTransByCountryOmp,
	fetchCredits,
	fetchBalanceDashboard
} from '../../../../redux/features/dashboard/dashboardSlice'
import {
	fetchDeclarations,
	fetchDeclarationsSalesTax,
	fetchEprDeclarations
} from '../../../../redux/features/declarations/declarationsSlice'
import { fetchDueDates } from '../../../../redux/features/dueDates/dueDatesSlice'
import { fetchPaymentInfo } from '../../../../redux/features/profile/profileSlice'
import { fetchCompanyDefaultCurrency } from '../../../../redux/features/user/userSlice'
import { fetchBonusProgram } from '../../../../redux/features/tax/taxSlice'
import { fetchThresholdEU, fetchThresholdUS } from '../../../../redux/features/thresholds/thresholdsSlice'

const defaultLimitDecl = 3
const defaulLimitDueDates = 4
const defaultLimitNews = 4
const defaulLimitThresholdUS = 10
const defaultLimitTransByCountryOmp = 10

/**
 * Custom hook to fetch dashboard data on mount
 * @param {Object} user - User object
 */
export const useDashboardData = (user) => {
	const dispatch = useAppDispatch()

	useEffect(() => {
		if (!user) return

		if (user.is_tax_agent || (user.is_manager && user.company.is_tax_agent)) {
			dispatch(fetchBonusProgram())
		} else {
			dispatch(fetchDueDates({ limit: defaulLimitDueDates }))
		}

		if (user.is_omp) {
			dispatch(fetchDeemedVat())
			dispatch(fetchTransByCountryOmp({
				limit: defaultLimitTransByCountryOmp,
			}))
		}

		dispatch(fetchLastUploadedTansation())
		dispatch(fetchNews({ limit: defaultLimitNews }))
		dispatch(fetchDeclarations({ limit: defaultLimitDecl }))
		dispatch(fetchDeclarationsSalesTax({ limit: defaultLimitDecl }))
		dispatch(fetchEprDeclarations({ limit: defaultLimitDecl }))
		dispatch(fetchThresholdEU({ year: new Date().getFullYear() }))
		dispatch(fetchCredits())
		dispatch(fetchThresholdUS({
			year: new Date().getFullYear(),
			limit: defaulLimitThresholdUS,
		}))
		dispatch(fetchPaymentInfo())
		dispatch(fetchCompanyDefaultCurrency())
		dispatch(fetchBalanceDashboard())
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.id]) // Only depend on user.id to prevent infinite loops
}

